function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Master",
  stroke: "none",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  transform: "translate(-40.000000, -318.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Status-icon/-Executed",
  transform: "translate(40.000000, 318.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16,8 C16,3.58333333 12.4166667,0 8,0 C3.58333333,0 0,3.58333333 0,8 C0,12.4166667 3.58333333,16 8,16 C12.4166667,16 16,12.4166667 16,8 Z",
  id: "Path",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  stroke: "#FFFFFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "12 4.66666667 6.4 11.3333333 4 8.66666667"
}))));

var SvgExecuted = function SvgExecuted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExecuted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/executed.4f8cc28e.svg";
export { ForwardRef as ReactComponent };